// TODO ダミーのQ&A文言のため決定次第、変更する

export const qAndA = [
  {
    question: '安否状況は誰でも閲覧できますか？',
    answer: '権限を与えられたユーザーであれば、閲覧可能です。',
  },
  {
    question: '地震の設定震度はいくつからですか？',
    answer: '震度4〜7までの6段階で設定可能です。',
  },
  {
    question: '管理者は何人設定できますか？',
    answer: '上限なく何人でも設定可能です。',
  },
  {
    question: 'AnpiCheckerは海外でも使用可能ですか？',
    answer:
      '日本の気象庁から災害情報を取得しているため、日本国内のみ使用可能です。',
  },
  {
    question:
      'ユーザーが"メール配信エラー"状態になっており、安否確認ができません',
    answer:
      '安否確認のメールが送信先に正常に配信されなかった場合、メール配信エラーの状態になりメールを送れない状態です。この場合はお手数ですが、一度ユーザーを削除し再度作成してください。',
  },
  {
    question: '検索した項目が表示されません',
    answer:
      '文字の先頭が検索語に一致する場合、検索が可能です。\n例：人事部\n検索条件が「人事」では検索すると抽出されます。\n検索条件が「事部」では検索しても抽出されません。',
  },
  {
    question: '管理者の初期パスワードは再送信可能ですか？',
    answer1: '再送信できません。以下の手順を参考に再登録を行ってください。',
    lists1: [
      {process: '同じチームでログイン可能な特権管理者・管理者に連絡する'},
      {process: '連絡を受けたユーザーが、対象の管理者を削除する'},
      {process: '対象の管理者のメールアドレスを再度登録する'},
      {
        process:
          '送信されたメールアドレスに添付されている初期パスワードを入力して、ログインする',
      },
    ],
  },
  {
    question: 'ユーザーにメールが届きません',
    answer: 'メール受信者にて、以下をご確認ください。',
    answer1: 'メールが受信できない場合 (全て)',
    lists1: [
      {
        process:
          '電波状況が悪くはありませんか？\n通信状況が悪い場合、受信に時間差が発生する可能性がございます。\n場所を移動したり、時間を置いてからもう一度受信ボックスを更新してください。\nまた、機内モードでないことをご確認ください。\n',
      },
      {
        process:
          '空き容量が足りなくなっていませんか？\nメールの空き容量不足により受信できない可能性があります。\n不要なメールを削除して、もう一度受信ボックスを更新してください。\n',
      },
    ],
    answer2: 'メールが受信できない場合 (AnpiCheckerからのみ)',
    lists2: [
      {
        process:
          '登録しているメールアドレスは合っていますか？\nAnpiCheckerに登録したメールアドレスが間違っていないか、ご確認ください。\n',
      },
      {
        process:
          '受信ボックス以外に届いてはいませんか？\n迷惑メールボックスを含めて、受信ボックス以外に届いていないか確認をお願い致します。\n',
      },
      {
        process:
          '迷惑メール設定をしていませんか？\n迷惑メールの設定により、メールが届かない可能性がございます。\nホワイトリスト(受信許可設定) にて以下のドメインをご登録ください。\nanpichecker.com\n\n設定方法はご利用のメールにより異なるため、必要に応じてメールソフトや携帯電話会社(キャリア)へのお問合せをお願い致します。\n',
      },
    ],
  },
  {
    question: 'ユーザーにSMSが届きません',
    answer: 'ユーザー(SMS受信者)にて、以下をご確認ください。',
    answer1: 'SMSが受信できない場合 (全て)',
    lists1: [
      {
        process:
          '電波状況が悪くはありませんか？\n通信状況が悪い場合、受信に時間差が発生する可能性がございます。\n場所を移動したり、しばらく時間を置いてからもう一度受信ボックスを更新してください。\nまた、機内モードでないことをご確認ください。\n',
      },
    ],
    answer2: 'SMSが受信できない場合 (AnpiCheckerからのみ)',
    lists2: [
      {
        process:
          '登録している電話番号は合っていますか？\nAnpiCheckerに登録した電話番号が間違っていないか、ご確認ください。\n',
      },
      {
        process:
          '迷惑メール設定をしていませんか？\nSMS迷惑メール設定により、SMSが届かない可能性がございます。\n設定確認をお願い致します。\n\nSMS迷惑メール設定を変更する際、以下にご注意ください。\n - 海外からの受信拒否は解除をお願い致します\n - URLリンクが記載されたSMSの受信拒否は解除をお願い致します\n - ホワイトリスト(受信許可設定)をご利用頂けません\n ※ AnpiCheckerは複数の電話番号を利用します\n  そのため、特定の電話番号を許可する受信設定ができません\n\n設定方法はご利用の携帯電話会社(キャリア)によって異なるため、必要に応じてお問合せをお願い致します。\n',
      },
    ],
  },
];
